"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    title: {
        id: 'authTemplates.login.title',
        defaultMessage: 'Log in',
        description: 'Login title',
    },
    description: {
        id: 'authTemplates.login.description',
        defaultMessage: 'Please enter your details.',
        description: 'Login description',
    },
    emailPlaceholder: {
        id: 'authTemplates.login.email.placeholder',
        defaultMessage: 'Enter your email',
        description: 'Login email placeholder',
    },
    registerPart1: {
        id: 'authTemplates.login.register.1',
        defaultMessage: 'Register using',
        description: 'Login register link part 1',
    },
    registerPart2: {
        id: 'authTemplates.login.register.2',
        defaultMessage: 'Activation code',
        description: 'Login register link part 2',
    },
    openRegisterPart1: {
        id: 'authTemplates.login.register.open.1',
        defaultMessage: 'No user account yet? Please ',
    },
    openRegisterPart2: {
        id: 'authTemplates.login.register.open.2',
        defaultMessage: 'Sign up',
    },
    successfullRegistration: {
        id: 'authTemplates.login.registeration.success',
        defaultMessage: 'You have successfully registered as a user with an AGCO account. Please enter your details.',
    },
    inactivityLogout: {
        id: 'authTemplates.login.inactivityLogout',
        defaultMessage: 'Your session has expired due to inactivity. Please log in again.',
    },
    notSureAboutText: {
        id: 'authTemplates.login.notSureAboutText',
        defaultMessage: 'Not sure about signing up?',
        description: 'Login not sure about text',
    },
    checkTheBenefitAnchor: {
        id: 'authTemplates.login.checkTheBenefitAnchor',
        defaultMessage: 'Check the benefits',
        description: 'Login check the benefit anchor',
    },
    loginCarouselTitle: {
        id: 'authTemplates.login.carousel.title',
        defaultMessage: 'Maximize your agco farmer experience!',
        description: 'Login carousel title',
    },
    carouselPsPDescription: {
        id: 'authTemplates.login.carousel.psp.description',
        defaultMessage: 'View your manufacture supported repair programs',
        description: 'Login carousel personalized service and support description',
    },
    carouselManualsDescription: {
        id: 'authTemplates.login.carousel.manuals.description',
        defaultMessage: 'Access your free operator manuals',
        description: 'Login carousel manuals and documents description',
    },
    carouselWarrantyDescription: {
        id: 'authTemplates.login.carousel.warranty.description',
        defaultMessage: "Check your machine's warranty details",
        description: 'Login carousel warranty description',
    },
    carouselFleetOverviewDescription: {
        id: 'authTemplates.login.carousel.fleetOverview.description',
        defaultMessage: 'Add machines to access details',
        description: 'Login carousel fleet overview description',
    },
    carouselDealerLocatorDescription: {
        id: 'authTemplates.login.carousel.dealerLocator.description',
        defaultMessage: 'Find your closest dealer',
        description: 'Login carousel dealer locator description',
    },
    carouselContactUsDescription: {
        id: 'authTemplates.login.carousel.contactUs.description',
        defaultMessage: 'Submit a ticket to get assistance',
        description: 'Login carousel contact us description',
    },
    carouselVideoDescription: {
        id: 'authTemplates.login.carousel.video.description',
        defaultMessage: 'Video help for your machinery needs',
        description: 'Login carousel video description',
    },
});
exports.default = messages;
